import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'
import axios from 'axios';
import AddPatientModal from './addPatient'; // Le composant modal
import EditPatientModal from './editPatient'; // Le composant modal
import {
    CButton,
    CRow,
    CCol,
    CCard,
    CCardBody,
    CTab,
    CTabContent,
    CTabList,
    CTabPanel,
    CTabs,
    CHeader, CContainer, CHeaderNav, CNavItem, CNavLink,
    CTable,
    CTableBody,
    CTableDataCell,
    CTableHead,
    CTableHeaderCell,
    CTableRow,
    CDropdown,
    CDropdownToggle,
    CDropdownMenu,
    CDropdownItem
} from '@coreui/react'
import { FaRedoAlt, FaExchangeAlt, FaFilter, FaSearch, FaDownload, FaFolderOpen, FaEllipsisV, FaEdit, FaSortAmountDown, FaSortAmountUp } from "react-icons/fa";
import { BsPersonPlus, BsChevronRight, BsChevronLeft, BsArrowUpLeft, BsArrowDownUp } from 'react-icons/bs';
import '../../../assets/css/mainstyle.css';
import '../../../assets/css/ClientSidebar.css';
import { usePermissions } from '../../../contexts/PermissionContext';
import Adminprofil from '../../../assets/images/adminprofil.png';
import { Tooltip } from 'react-tooltip'

import api from '../../../service/caller';
import { ToastContainer, toast } from 'react-toastify';

const PatientList = () => {
    const [UserData, setUserData] = useState([]);
    const [visibleEdit, setVisibleEdit] = useState(false);
    const [visible, setVisible] = useState(false);
    const [appointments, setAppointments] = useState([]);
    const [patients, setPatients] = useState([]);
    const [filteredPatients, setFilteredPatients] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [totalPatients, setTotalPatients] = useState(0);
    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState(false);
    const limit = 10; // Nombre de patients par page
    const [selectedUser, setSelectedUser] = useState(null);
    const { hasPermission } = usePermissions();

    // Filter states
    const [filterOptions, setFilterOptions] = useState({
        address: '',
        lastVisit: '',
        isActive: 'all'
    });
    const [sortOption, setSortOption] = useState('nameAsc'); // Default sort by name ascending
    const [isFiltering, setIsFiltering] = useState(false);

    useEffect(() => {
        const fetchLoggedUserData = async () => {
            try {
                const response = await api.get('api/usersprofile');
                setUserData(response.data);
            } catch (error) {
                toast.error("Failed to fetch data");
            }
        };
        fetchLoggedUserData();
    }, []);

    const fetchPatients = async (hospitalIds) => {
        if (!hospitalIds || hospitalIds.length === 0) {
            console.error("Erreur: hospitalIds est vide ou non disponible");
            return;
        }
        try {
            // Faire l'appel API avec un tableau de hospitalIds
            const response = await api.get(`/clinic/patients`, {
                params: { hospitalIds } // Envoi d'un tableau d'IDs de hospital
            });
            setPatients(response.data.patients);
            setFilteredPatients(response.data.patients);
            setTotalPatients(response.data.patients.length);
            calculateTotalPages(response.data.patients.length);

        } catch (error) {
            console.error('Erreur lors de la récupération des patients:');
            if (error.response) {
                console.error('Données de réponse:', error.response.data);
                console.error('Statut:', error.response.status);
            } else if (error.request) {
                console.error('Requête sans réponse:', error.request);
            } else {
                console.error('Erreur de configuration:', error.message);
            }
        }
    };

    // Utilisation de useEffect pour charger les données
    useEffect(() => {
        if (UserData && UserData.hospital_id && Array.isArray(UserData.hospital_id) && UserData.hospital_id.length > 0) {
            const hospitalIds = UserData.hospital_id;
            fetchPatients(hospitalIds);
        } else {
            console.error("UserData ou hospital_id non disponible pour fetchPatients");
        }
    }, [UserData]);

    useEffect(() => {
        const fetchAppointments = async () => {
            try {
                const token = localStorage.getItem('access_token');
                if (!token) {
                    throw new Error('Token not found');
                }

                const hospitalIds = Array.isArray(UserData.hospital_id) ? UserData.hospital_id : [UserData.hospital_id];

                // Créez une requête pour chaque hospitalId
                const promises = hospitalIds.map(hospitalId =>
                    api.get(`/clinic/getAppointmentlist?hospitalId=${hospitalId._id || hospitalId}`, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                );

                const responses = await Promise.all(promises);

                // Combiner toutes les données des réponses
                const allAppointments = responses.flatMap(response => response.data);

                setAppointments(allAppointments);

                // Filtrer les rendez-vous selon l'utilisateur
                if (UserData.role && UserData.role.name === 'medtinz_client_patient') {
                    const patientResponse = await api.get('/clinic/getPatientByUserId', {
                        headers: { Authorization: `Bearer ${token}` }
                    });

                    const patientId = patientResponse.data._id;
                    const filteredAppointments = allAppointments.filter(appointment =>
                        appointment.patientId._id === patientId
                    );

                    setAppointments(filteredAppointments);
                }
            } catch (error) {
                console.error('Error fetching appointments:', error);
                toast.error("Failed to fetch appointments");
            }
        };

        if (UserData && UserData.hospital_id) {
            fetchAppointments();
        }
    }, [UserData]);

    // Calculate total pages for pagination
    const calculateTotalPages = (totalItems) => {
        setTotalPages(Math.ceil(totalItems / limit));
    };

    // Enhanced search function
    const handleSearchChange = (e) => {
        const value = e.target.value;
        setSearchTerm(value);

        // If search term is empty and no filters are active, show all patients
        if (!value && !isFiltering) {
            setFilteredPatients(patients);
            setTotalPatients(patients.length);
            calculateTotalPages(patients.length);
            return;
        }

        // Filter patients based on search term
        filterAndSortPatients(value, filterOptions, sortOption);
    };

    // Filter and sort patients based on current criteria
    const filterAndSortPatients = (search = searchTerm, filters = filterOptions, sort = sortOption) => {
        setLoading(true);
        let results = [...patients];

        // Apply search filter if there's a search term
        if (search) {
            search = search.toLowerCase();
            results = results.filter(patient =>
                patient.patientId?.toLowerCase().includes(search) ||
                patient.firstname?.toLowerCase().includes(search) ||
                patient.lastname?.toLowerCase().includes(search) ||
                patient.phone?.includes(search) ||
                patient.email?.toLowerCase().includes(search)
            );
        }

        // Apply additional filters
        if (filters.address) {
            results = results.filter(patient =>
                patient.address?.toLowerCase().includes(filters.address.toLowerCase())
            );
        }

        if (filters.isActive !== 'all') {
            const isActiveValue = filters.isActive === 'active';
            results = results.filter(patient => patient.isActive === isActiveValue);
        }

        // Apply sorting
        switch (sort) {
            case 'nameAsc':
                results.sort((a, b) => (a.lastname || '').localeCompare(b.lastname || ''));
                break;
            case 'nameDesc':
                results.sort((a, b) => (b.lastname || '').localeCompare(a.lastname || ''));
                break;
            case 'idAsc':
                results.sort((a, b) => (a.patientId || '').localeCompare(b.patientId || ''));
                break;
            case 'idDesc':
                results.sort((a, b) => (b.patientId || '').localeCompare(a.patientId || ''));
                break;
            default:
                break;
        }

        setFilteredPatients(results);
        setTotalPatients(results.length);
        calculateTotalPages(results.length);
        setLoading(false);
    };

    // Apply filters
    const applyFilters = () => {
        setIsFiltering(true);
        filterAndSortPatients();
    };

    // Reset filters
    const resetFilters = () => {
        setFilterOptions({
            address: '',
            lastVisit: '',
            isActive: 'all'
        });
        setSortOption('nameAsc');
        setSearchTerm('');
        setIsFiltering(false);
        setFilteredPatients(patients);
        setTotalPatients(patients.length);
        calculateTotalPages(patients.length);
    };

    // Handle filter changes
    const handleFilterChange = (field, value) => {
        setFilterOptions(prev => ({
            ...prev,
            [field]: value
        }));
    };

    // Handle sort option change
    const handleSortChange = (option) => {
        setSortOption(option);
        filterAndSortPatients(searchTerm, filterOptions, option);
    };

    // Pagination
    const goToNextPage = () => {
        if (currentPage < totalPages) setCurrentPage((prevPage) => prevPage + 1);
    };

    const goToPreviousPage = () => {
        if (currentPage > 1) setCurrentPage((prevPage) => prevPage - 1);
    };

    const handlePatientAdded = (newPatient) => {
        setPatients((prev) => [...prev, newPatient]);
        setFilteredPatients((prev) => [...prev, newPatient]);
    };

    const handlePatientEdited = (editedPatient) => {
        const updatedPatients = patients.map(patient =>
            patient._id === editedPatient._id ? editedPatient : patient
        );
        setPatients(updatedPatients);
        setFilteredPatients(updatedPatients);
    };

    const handleEditClick = (user) => {
        setSelectedUser(user);
        setVisibleEdit(true);
    };

    // Nouvelle fonction pour enregistrer l'accès au dossier du patient
    const logPatientAccess = async (patientId) => {
        try {
            // Vérifiez qu'on a les informations nécessaires
            if (!patientId || !UserData._id) {
                console.error("Information manquante pour la journalisation d'accès");
                return;
            }

            // Préparer les données du log
            const logData = {
                patientId: patientId,
                userId: UserData._id,
                userName: `${UserData.firstname} ${UserData.lastname}`,
                userRole: UserData.role?.name || 'Unknown',
                accessType: 'view_file',
                timestamp: new Date(),
                hospitalId: Array.isArray(UserData.hospital_id) ? UserData.hospital_id[0]._id || UserData.hospital_id[0] : UserData.hospital_id
            };

            // Envoyer les données au serveur
            const response = await api.post('clinic/access-log', logData);

        } catch (error) {
            console.error('Erreur lors de l\'enregistrement de l\'accès au dossier patient:', error);
            // Ne pas afficher d'erreur à l'utilisateur pour ne pas interrompre son flux de travail
        }
    };

    // Wrapper pour les liens d'accès aux dossiers patients
    const handleFileAccess = (patientId) => {
        logPatientAccess(patientId);
    };

    // Get current page items
    const getCurrentPageItems = () => {
        const startIndex = (currentPage - 1) * limit;
        const endIndex = startIndex + limit;
        return filteredPatients.slice(startIndex, endIndex);
    };

    return (
        <div className="dashboard-header">
            {/* <div className='row px-4'>
                <div className='col-lg-4 mb-3'>
                    <div className="pagetittle">
                        <h4 className='text-start'><b>Patient Management</b></h4>
                    </div>
                </div>
                <div className='col-lg-4'></div>
                <div className='col-lg-4 mx-auto'>
                    <div className="d-flex flex-column flex-md-row justify-content-end gap-4">
                        <div>
                            <img src={UserData?.picture || Adminprofil} className='cardicon' alt="Consultation Icon" width={'50'} height={'50'} />
                        </div>
                        <div>
                            <span className="ms-2" style={{ color: 'black', fontSize: '18px' }}>{UserData.firstname} {UserData.lastname}</span>
                            <p className="ms-2" style={{ color: 'black', fontSize: '18px', display: 'flex', flexWrap: 'wrap' }}>{UserData.role?.name}</p>
                        </div>
                    </div>
                </div>
            </div> */}


            <div className="hosp-profile-header" style={{ backgroundColor: 'var(--hosp-background-color)', border: "none" }}>
                <div className="hosp-header__content">
                    <div className="hosp-header__title">
                        <h4 className="hosp-page__title"><b>Patient Management</b></h4>
                    </div>

                    <div className="hosp-user__profile">
                        <div className="hosp-status__indicator"></div>

                        <img src={UserData?.picture || Adminprofil} className='hosp-profile__image' alt="Consultation Icon"/>

                        <div className="hosp-user__details">
                            <span className="ms-2" style={{ color: 'black', fontSize: '18px' }} >{UserData.firstname} {UserData.lastname}</span>
                            <p className="ms-2" style={{ color: 'black', fontSize: '18px', display: 'flex', flexWrap: 'wrap' }} >{UserData.role?.name}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="Patientlist mt-4">
                <div className='tabsection'>
                    <CRow>
                        <CCol xs={12}>
                            <CCard className="card mb-4 p-4">
                                <CCardBody>
                                    <CTabs activeItemKey="Allpatient">
                                        <CTabList variant="underline" className='border-bottom mx-auto'>
                                            <CTab itemKey="Allpatient">All Patient</CTab>
                                            {/* <CTab itemKey="dayrecord">Day's record</CTab> */}
                                        </CTabList>
                                        <CTabContent>
                                            <CTabPanel className="p-3" itemKey="Allpatient">
                                                <div className='tablist'>
                                                    <div className='row'>
                                                        <div className="col-lg-9 mb-4">
                                                            <div className="search-container w-100">
                                                                <div className="search-bar">
                                                                    <FaSearch size="sm" className="search-icon" style={{ width: '20px', height: '20px' }} />
                                                                    <input
                                                                        className='ms-4 w-100'
                                                                        type="text"
                                                                        placeholder="Search for a patient (Enter ID, name or Tel)"
                                                                        value={searchTerm}
                                                                        onChange={handleSearchChange}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3 mb-4">
                                                            <div className="">
                                                                <CButton
                                                                    onClick={() => setVisible(true)}
                                                                    className="btn-primary"
                                                                    active tabIndex={-1}
                                                                    style={{
                                                                        backgroundColor: '#0056B3',
                                                                        color: 'white',
                                                                        width: '100%',
                                                                        padding: '10px 20px',
                                                                        borderRadius: '20px'
                                                                    }}
                                                                >
                                                                    <BsPersonPlus className='mx-2' />
                                                                    Register New patient
                                                                </CButton>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <AddPatientModal
                                                        visible={visible}
                                                        onClose={() => setVisible(false)}
                                                        onPatientAdded={handlePatientAdded}
                                                    />

                                                    <div className='mt-3'>
                                                        <div className="filter-bar">
                                                            <CDropdown>
                                                                <CDropdownToggle color="light" className="filter-button hvr"
                                                                    style={{
                                                                        color: '#0056B3',
                                                                        padding: '10px 20px',
                                                                        borderRadius: '20px'
                                                                    }}
                                                                >
                                                                    Sort By<FaExchangeAlt className="icon ms-2" />
                                                                </CDropdownToggle>
                                                                <CDropdownMenu>
                                                                    <CDropdownItem onClick={() => handleSortChange('nameAsc')}>
                                                                        <FaSortAmountDown className="me-2" /> Name (A-Z)
                                                                    </CDropdownItem>
                                                                    <CDropdownItem onClick={() => handleSortChange('nameDesc')}>
                                                                        <FaSortAmountUp className="me-2" /> Name (Z-A)
                                                                    </CDropdownItem>
                                                                    <CDropdownItem onClick={() => handleSortChange('idAsc')}>
                                                                        <FaSortAmountDown className="me-2" /> ID (Ascending)
                                                                    </CDropdownItem>
                                                                    <CDropdownItem onClick={() => handleSortChange('idDesc')}>
                                                                        <FaSortAmountUp className="me-2" /> ID (Descending)
                                                                    </CDropdownItem>
                                                                </CDropdownMenu>
                                                            </CDropdown>
                                                            <div className='ms-2'>
                                                                <button className="btn btn-reset hvr"
                                                                    onClick={resetFilters}
                                                                    style={{
                                                                        color: '#0056B3',
                                                                        padding: '10px 20px',
                                                                        borderRadius: '20px'
                                                                    }}
                                                                >
                                                                    <FaRedoAlt className="icon me-2" /> Reset Filter
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='patientlisttable'>
                                                        {loading ? (
                                                            <div className="text-center my-5">
                                                                <div className="spinner-border text-primary" role="status">
                                                                    <span className="visually-hidden">Loading...</span>
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <CTable className="mt-5 ctable-no-border" align="middle" responsive>
                                                                <CTableHead>
                                                                    <CTableRow className='tablehead'>
                                                                        <CTableHeaderCell scope="col" width="60">#</CTableHeaderCell>
                                                                        <CTableHeaderCell scope="col">ID</CTableHeaderCell>
                                                                        <CTableHeaderCell scope="col">NAME</CTableHeaderCell>
                                                                        <CTableHeaderCell scope="col">ADDRESS</CTableHeaderCell>
                                                                        <CTableHeaderCell scope="col">EMAIL</CTableHeaderCell>
                                                                        <CTableHeaderCell scope="col">PHONE</CTableHeaderCell>
                                                                        <CTableHeaderCell scope="col">ACTION</CTableHeaderCell>
                                                                    </CTableRow>
                                                                </CTableHead>
                                                                <CTableBody>
                                                                    {getCurrentPageItems().map((patient, index) => (
                                                                        <CTableRow className='ctable-row' key={patient._id}>
                                                                            <CTableDataCell align="middle">{(currentPage - 1) * limit + index + 1}</CTableDataCell>
                                                                            <CTableDataCell align="middle">{patient.patientId}</CTableDataCell>
                                                                            <CTableDataCell>{patient.lastname} {patient.firstname}</CTableDataCell>
                                                                            <CTableDataCell>{patient.address}</CTableDataCell>
                                                                            <CTableDataCell>{patient.email}</CTableDataCell>
                                                                            <CTableDataCell>{patient.phone}</CTableDataCell>
                                                                            <CTableDataCell>
                                                                                <div className="flex items-center space-x-4">
                                                                                    <div className="dropdown-center p-0 bg-none" style={{ border: 'none' }}>
                                                                                        <FaEllipsisV
                                                                                            className="bg-none border-0 p-0"
                                                                                            data-coreui-toggle="dropdown"
                                                                                            aria-expanded="true"
                                                                                            style={{ border: 'none', color: 'Green' }}
                                                                                        />
                                                                                        <ul className="dropdown-menu">
                                                                                            <li>
                                                                                                <Link
                                                                                                    className="dropdown-item"
                                                                                                    to={`/hospitaladmin/patientfilemedical/${patient._id}`}
                                                                                                    onClick={() => logPatientAccess(patient._id)}
                                                                                                >
                                                                                                    <FaFolderOpen
                                                                                                        className="bg-none border-0 p-0"
                                                                                                        data-coreui-toggle="dropdown"
                                                                                                        aria-expanded="true"
                                                                                                        style={{ border: 'none' }}
                                                                                                    /> Open Folder
                                                                                                </Link>
                                                                                            </li>

                                                                                            {hasPermission('medtinz_client_patient_update') && (
                                                                                                <li>
                                                                                                    <CButton
                                                                                                        onClick={() => handleEditClick(patient)}
                                                                                                        className="dropdown-item bg-none border-0" tabIndex={-1}>
                                                                                                        <FaEdit
                                                                                                            className="bg-none border-0 p-0"
                                                                                                            data-coreui-toggle="dropdown"
                                                                                                            aria-expanded="true"
                                                                                                            style={{ border: 'none' }}
                                                                                                        /> Edit {patient?.firstname}
                                                                                                    </CButton>
                                                                                                    <EditPatientModal
                                                                                                        visibleEdit={visibleEdit}
                                                                                                        patientSelected={selectedUser}
                                                                                                        onClose={() => setVisibleEdit(false)}
                                                                                                        onPatientEdit={handlePatientEdited}
                                                                                                    />
                                                                                                </li>
                                                                                            )}

                                                                                            <li>
                                                                                                <Link
                                                                                                    className="dropdown-item"
                                                                                                    to={`/patientcard/${patient._id}`}
                                                                                                    onClick={() => logPatientAccess(patient._id)}
                                                                                                >
                                                                                                    <FaDownload
                                                                                                        className="bg-none border-0 p-0"
                                                                                                        data-coreui-toggle="dropdown"
                                                                                                        aria-expanded="true"
                                                                                                        style={{ border: 'none' }}
                                                                                                    /> Download
                                                                                                </Link>
                                                                                            </li>
                                                                                        </ul>
                                                                                    </div>
                                                                                </div>
                                                                            </CTableDataCell>
                                                                        </CTableRow>
                                                                    ))}
                                                                    {filteredPatients.length === 0 && (
                                                                        <CTableRow>
                                                                            <CTableDataCell colSpan="6" className="text-center py-5">
                                                                                No patients found matching your criteria.
                                                                            </CTableDataCell>
                                                                        </CTableRow>
                                                                    )}
                                                                </CTableBody>
                                                            </CTable>
                                                        )}
                                                    </div>

                                                    {/* Pagination */}
                                                    <div className='paginate me-5'>
                                                        <p className='mt-3'>
                                                            Showing {filteredPatients.length > 0 ? (currentPage - 1) * limit + 1 : 0}-
                                                            {Math.min(currentPage * limit, totalPatients)} of {totalPatients}
                                                        </p>
                                                        <div className='actionbtn'>
                                                            <div className={`left ${currentPage <= 1 ? 'disabled' : ''}`} onClick={goToPreviousPage}>
                                                                <BsChevronLeft className='pagicon' />
                                                            </div>
                                                            <div className={`right ${currentPage >= totalPages ? 'disabled' : ''}`} onClick={goToNextPage}>
                                                                <BsChevronRight className='pagicon' />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </CTabPanel>

                                            {/* Day's Record Tab */}
                                            <CTabPanel className="p-3" itemKey="dayrecord">
                                                <div className='tablist'>
                                                    <div className='patientlistline'>
                                                        <div className="search-container w-80">
                                                            <div className="search-bar">
                                                                <FaSearch size="sm" className="search-icon" style={{ width: '20px', height: '20px' }} />
                                                                <input
                                                                    className='ms-4'
                                                                    type="text"
                                                                    placeholder="Search for a patient (Enter ID, name or Tel)"
                                                                    value={searchTerm}
                                                                    onChange={handleSearchChange}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className='registeruserbtn ms-auto'>
                                                            <CButton onClick={() => setVisible(true)} className="registernewbtn ms-auto d-flex align-items-center" active tabIndex={-1}>
                                                                <BsPersonPlus className='mx-2' /> Register New patient
                                                            </CButton>
                                                        </div>
                                                    </div>

                                                    <div className='patientlisttable'>
                                                        <CTable className="mt-5 ctable-no-border" align="middle" responsive>
                                                            <CTableHead>
                                                                <CTableRow className='tablehead'>
                                                                    <CTableHeaderCell scope="col">ID</CTableHeaderCell>
                                                                    <CTableHeaderCell scope="col">NAME</CTableHeaderCell>
                                                                    <CTableHeaderCell scope="col">ADDRESS</CTableHeaderCell>
                                                                    <CTableHeaderCell scope="col">PHONE</CTableHeaderCell>
                                                                    <CTableHeaderCell scope="col">STATUS</CTableHeaderCell>
                                                                    <CTableHeaderCell scope="col">PAYMENT STATUS</CTableHeaderCell>
                                                                    <CTableHeaderCell scope="col">Patient FILE</CTableHeaderCell>
                                                                </CTableRow>
                                                            </CTableHead>
                                                            <CTableBody>
                                                                {appointments.map((appointment) => (
                                                                    <CTableRow className="ctable-row" key={appointment._id}>
                                                                        <CTableDataCell>{appointment.patientId?.patientId || 'N/A'}</CTableDataCell>
                                                                        <CTableDataCell>{appointment.patientId?.firstname || 'Unknown'} {appointment.patientId?.lastname || 'Unknown'}</CTableDataCell>
                                                                        <CTableDataCell>{appointment.patientId?.address || 'N/A'}</CTableDataCell>
                                                                        <CTableDataCell>{appointment.patientId?.phone || 'N/A'}</CTableDataCell>
                                                                        <CTableDataCell>
                                                                            <span className={appointment.paymentStatus ? 'coloredsucess' : 'coloredwarning'}>
                                                                                {appointment.paymentStatus ? 'Paid' : 'Pending'}</span>
                                                                        </CTableDataCell>
                                                                        <CTableDataCell>
                                                                            <span className={appointment.status === 'Scheduled' ? 'coloredsucess' : 'coloredechec'}>
                                                                                {appointment.status}
                                                                            </span>
                                                                        </CTableDataCell>
                                                                        <CTableDataCell>
                                                                            <Link
                                                                                to={`/hospitaladmin/patientfilemedical/${appointment.patientId?._id}`}
                                                                                className="openfilepatient"
                                                                                onClick={() => logPatientAccess(appointment.patientId?._id)}
                                                                            >
                                                                                <BsArrowUpLeft /> Open patient file
                                                                            </Link>
                                                                        </CTableDataCell>
                                                                    </CTableRow>
                                                                ))}
                                                            </CTableBody>
                                                        </CTable>
                                                    </div>
                                                </div>
                                            </CTabPanel>
                                        </CTabContent>
                                    </CTabs>
                                </CCardBody>
                            </CCard>
                        </CCol>
                    </CRow>
                </div>
            </div>
            <ToastContainer />
        </div>
    );
}

export default PatientList;